import React, { memo } from "react"
import { Theme } from "@emotion/react"
import { SocialMedia } from "./SocialMedia"
import BottomFooter from "./BottomFooter"
import ContactUs from "./ContactUs"
import { footerStyle, contactContainerStyle } from "./style"
import ShopFooter from "./ShopFooter"
import AddressFooter from "./Address"

export const SiteFooter: React.FC = memo(() => (
	<footer css={footerStyle}>
		<div className="innerFooter">
			<AddressFooter />
			<ShopFooter />
			<div css={contactContainerStyle}>
				<ContactUs />
				<SocialMedia />
			</div>
		</div>
		<BottomFooter />
	</footer>
))

export default SiteFooter
